import { api } from '@/lib/api'

import { CompanyOwner } from '../types'

export function createBeneficialOwner(data: Omit<CompanyOwner, 'id'>) {
  return api.post<CompanyOwner>(`/v1/onboarding/beneficial-owners`, data)
}
